import { useWindowWidth } from '@react-hook/window-size';
import React from 'react';

const InfoCircle: React.FC = () => {
  const isMobile = useWindowWidth() < 680;

  return (
    <span
      style={{
        display: 'inline-block',
        width: isMobile ? '36px' : '16px',
        height: '16px',
        fontSize: '12px',
        lineHeight: '18px',
        letterSpacing: 'initial',
        fontWeight: 800,
        textTransform: 'none',
        textAlign: 'center',
        color: '#fff',
        background: 'var(--color-brand-primary)',
        borderRadius: '8px',
        border: 0,
      }}
    >
      i
    </span>
  );
};

InfoCircle.defaultProps = {
  style: {},
};

export { InfoCircle };
